module.exports = require("./fr");